
















import {Component, Prop, Vue} from 'vue-property-decorator'
import { getPartnerCompanyNoticeInfo} from "@/api/workbench"
import { Getter } from 'vuex-class'

@Component
export default class Message extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string
  @Prop({default:'#fff'}) background:string
  @Prop({default:'0'}) padding:string

  text= ''
  activated(){
    this.getPartnerCompanyNoticeInfo()
  }
  
  getPartnerCompanyNoticeInfo() {
    this.$log.setLog({
      file: 'NoticeBar/index.vue',
      name: 'getPartnerCompanyNoticeInfo方法',
      type: '函数执行'
    })
    getPartnerCompanyNoticeInfo({ partnerCompanyId: this.partnerCompanyId }).then((res) => {
      console.log('getPartnerCompanyNoticeInfo************', res)
      this.text = res.data?.content || ''
      this.$log.setLog({
        file: 'NoticeBar/index.vue',
        name: 'getPartnerCompanyNoticeInfo方法',
        type: '函数执行-成功'
      })
    }).catch((err) => {
      this.$log.setLog({
        file: 'NoticeBar/index.vue',
        name: 'getPartnerCompanyNoticeInfo方法',
        type: '函数执行-失败',
        data: err
      })
    })
  }
  
}
